import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "offer-subtotal-list" }
const _hoisted_2 = { class: "ml-3" }
const _hoisted_3 = {
  key: 0,
  class: "text-lyft"
}
const _hoisted_4 = { class: "ml-3" }
const _hoisted_5 = {
  key: 1,
  class: "text-primary"
}
const _hoisted_6 = /*#__PURE__*/_createElementVNode("span", null, "Openbay+ Savings:", -1)
const _hoisted_7 = { class: "ml-3" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("span", null, "Taxes:", -1)
const _hoisted_9 = { class: "ml-3" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_icon = _resolveComponent("icon")!

  return (_openBlock(), _createElementBlock("ul", _hoisted_1, [
    _createElementVNode("li", null, [
      _createElementVNode("span", null, _toDisplayString(_ctx.subTotalLabel) + ":", 1),
      _createElementVNode("span", _hoisted_2, _toDisplayString(_ctx.subTotal), 1)
    ]),
    (_ctx.displayLyftDiscount)
      ? (_openBlock(), _createElementBlock("li", _hoisted_3, [
          _createElementVNode("span", null, [
            _createVNode(_component_icon, {
              class: "text-lyft mr-1",
              size: "lg",
              icon: ['fab', 'lyft']
            }),
            _createTextVNode("Driver Savings:")
          ]),
          _createElementVNode("span", _hoisted_4, "- " + _toDisplayString(_ctx.partnerDiscount), 1)
        ]))
      : _createCommentVNode("", true),
    (_ctx.plusSubscriber)
      ? (_openBlock(), _createElementBlock("li", _hoisted_5, [
          _hoisted_6,
          _createElementVNode("span", _hoisted_7, "- " + _toDisplayString(_ctx.subscriberDiscount), 1)
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("li", null, [
      _hoisted_8,
      _createElementVNode("span", _hoisted_9, _toDisplayString(_ctx.totalTaxes), 1)
    ])
  ]))
}